const cookie = {
  set (key: string, val: any, maxAgeHrs: number) {
    const date = new Date();
    const time = date.getTime();
    const expireTime = time + maxAgeHrs * 60 * 60 * 1000;
    date.setTime(expireTime);
    const expires = date.toUTCString();
    const encodedJson = encodeURIComponent(JSON.stringify(val));
    document.cookie = key + "=" + encodedJson + ";expires=" + expires + ";path=/";
  },
  get (key: string) {
    if (document && document.cookie) {
      const foundCookie = (document as any).cookie
        .split("; ")
        .map((c: any) => c.split("="))
        .find((cp: any) => cp[0] === key);

      if (foundCookie) {
        return decodeURIComponent(foundCookie[1]);
      }
    }
    return null;
  }
};

export default cookie;